"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberInputFieldCompact = void 0;
const react_1 = __importStar(require("react"));
const react_tooltip_1 = __importDefault(require("react-tooltip"));
const NumberInputFieldCompact_styles_1 = require("./NumberInputFieldCompact.styles");
const NumberInputFieldCompact = (_a) => {
    var { id, required, value, autoFocus, disabled, enableHotJar, errorText, warningText, tooltip, onBlur, onFocus, onChange, placeholder, step, unit, min, max } = _a, rest = __rest(_a, ["id", "required", "value", "autoFocus", "disabled", "enableHotJar", "errorText", "warningText", "tooltip", "onBlur", "onFocus", "onChange", "placeholder", "step", "unit", "min", "max"]);
    const unitRef = (0, react_1.useRef)(null);
    const [unitHeight, setUnitHeight] = (0, react_1.useState)(0);
    (0, react_1.useLayoutEffect)(() => {
        // We can't calculate layout until custom fonts
        // have loaded. Calling getBoundingClientRect before custom fonts
        // have loaded will result in incorrect values.
        document.fonts.ready.then(() => {
            if (unitRef.current !== null) {
                const { height } = unitRef.current.getBoundingClientRect();
                setUnitHeight(height);
            }
            else {
                setUnitHeight(0);
            }
        });
    }, [unit]);
    const onFocusFn = (0, react_1.useMemo)(() => () => {
        if (onFocus) {
            onFocus();
        }
    }, [onFocus]);
    const onBlurFn = (0, react_1.useMemo)(() => () => {
        if (onBlur) {
            onBlur();
        }
    }, [onBlur]);
    const onChangeFn = (event) => {
        const newValue = event.target.valueAsNumber;
        if (onChange) {
            onChange(newValue);
        }
    };
    return (react_1.default.createElement(NumberInputFieldCompact_styles_1.InputGroup, { className: "tooltipClass" },
        tooltip && (react_1.default.createElement(react_tooltip_1.default, { id: "sbt", effect: "solid", place: "bottom" }, tooltip)),
        react_1.default.createElement(NumberInputFieldCompact_styles_1.Input, Object.assign({ id: id, required: required, className: enableHotJar ? "data-hj-allow" : undefined, autoFocus: autoFocus, type: "number", "$hasValue": value && value !== "", value: isNaN(value) ? "" : value, onChange: (e) => onChangeFn(e), onClick: (event) => event.stopPropagation(), "$hasWarning": !!warningText, "$hasError": !!errorText, disabled: disabled, placeholder: placeholder, onFocus: onFocusFn, onBlur: onBlurFn, step: step, min: min, max: max, "data-tip": true, "data-for": "sbt" }, rest)),
        unit && (react_1.default.createElement(NumberInputFieldCompact_styles_1.InputSuffixWrapper, { "$unitHeight": unitHeight, ref: unitRef, "$hasError": !!errorText, "$hasWarning": !!warningText, "$disabled": disabled }, unit))));
};
exports.NumberInputFieldCompact = NumberInputFieldCompact;
//# sourceMappingURL=NumberInputFieldCompact.js.map